import styled from 'styled-components';
import { colors } from '../../../stylesheets';

export const StyledInsideLoaderWrapper = styled.div((props) => ({
  position: 'absolute',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: colors.palePrimary,
  color: 'white',
  height: '100%',
  width: '100%',
}));
